import { ErrorFeedback } from 'common-components/view-logic'

const RiderMessage = ({ riderCode, messages, type }) => {
  if (messages.length === 0) {
    return null
  }
  return (
    <div>
      <ErrorFeedback
        id={`${riderCode}-rider-error-messages`}
        errorMessages={messages}
        messageType={`${type}-message`}
      />
    </div>
  )
}

export default RiderMessage
